import { colors } from "constants/theme";


export default function ProfileCheck(props: { stroke?: string, fill?: string, width?: string, height?: string }) {
    return (
        <svg width={props.width || '20'} height={props.height || '16'} viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_280_30292)">
                <path d="M20.1 6.85455C20.1 6.97576 20.0566 7.07879 19.9699 7.16364L16.6068 10.4545L15.9751 11.0727C15.8884 11.1576 15.7831 11.2 15.6592 11.2C15.5354 11.2 15.4301 11.1576 15.3434 11.0727L14.7116 10.4545L13.0301 8.80909C12.9434 8.72425 12.9 8.62122 12.9 8.5C12.9 8.37879 12.9434 8.27576 13.0301 8.19091L13.6618 7.57273C13.7485 7.48788 13.8538 7.44546 13.9777 7.44546C14.1015 7.44546 14.2068 7.48788 14.2935 7.57273L15.6592 8.91364L18.7065 5.92728C18.7932 5.84243 18.8985 5.8 19.0223 5.8C19.1462 5.8 19.2515 5.84243 19.3382 5.92728L19.9699 6.54546C20.0566 6.63031 20.1 6.73334 20.1 6.85455Z" fill={props.fill || colors.white} />
                <g clipPath="url(#clip1_280_30292)">
                    <path d="M7 9C9.20938 9 11 7.20937 11 5C11 2.79063 9.20938 1 7 1C4.79063 1 3 2.79063 3 5C3 7.20937 4.79063 9 7 9ZM9.8 10H9.27812C8.58437 10.3188 7.8125 10.5 7 10.5C6.1875 10.5 5.41875 10.3188 4.72188 10H4.2C1.88125 10 0 11.8813 0 14.2V15.5C0 16.3281 0.671875 17 1.5 17H12.5C13.3281 17 14 16.3281 14 15.5V14.2C14 11.8813 12.1187 10 9.8 10Z" fill={props.fill || colors.white} stroke={props.stroke || colors.lightGray} />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_280_30292">
                    <rect width="20" height="17" fill={props.fill || colors.white} />
                </clipPath>
                <clipPath id="clip1_280_30292">
                    <rect width="14" height="16" fill={props.fill || colors.white} transform="translate(0 1)" />
                </clipPath>
            </defs>
        </svg>
    )
}
